var _defs, _polyline, _polyline2, _line, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoefTempProfil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a83e995d-be3d-483c-bb20-9af443aaa5c3",
    "data-name": "coef_temp_profil",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ac91a159-6e5f-459b-b0d8-f7558dcdaed1,.b68efef9-b17a-4f64-a3b4-b36a545fecf5,.b891ea08-ce1c-4bc2-8ddf-94860d0947f0,.bcea656e-168c-4822-a4e6-1c1a2f0a8027,.ef8f3009-13e4-4b32-9373-4f26c104f898{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;}.b891ea08-ce1c-4bc2-8ddf-94860d0947f0{stroke-width:10px;}.bcea656e-168c-4822-a4e6-1c1a2f0a8027{stroke-width:5px;}.ef8f3009-13e4-4b32-9373-4f26c104f898{stroke-width:8px;}.b68efef9-b17a-4f64-a3b4-b36a545fecf5{stroke-width:3px;}.ac91a159-6e5f-459b-b0d8-f7558dcdaed1{stroke-width:6px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "coef_temp_profil") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "b891ea08-ce1c-4bc2-8ddf-94860d0947f0",
    points: "195 149.5 49.5 149.5 49.5 5"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "b891ea08-ce1c-4bc2-8ddf-94860d0947f0",
    points: "195 101 98 101 98 5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "bcea656e-168c-4822-a4e6-1c1a2f0a8027",
    x1: 99,
    y1: 100,
    x2: 50,
    y2: 149
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b196fcb9-35cc-435c-ad7a-ae5e384605f2",
    "data-name": "termostat_mic copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ef8f3009-13e4-4b32-9373-4f26c104f898",
    d: "M35.41,161.06a19.5,19.5,0,1,1-23.85,0"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef8f3009-13e4-4b32-9373-4f26c104f898",
    x1: 12,
    y1: 160,
    x2: 12,
    y2: 117
  }), /*#__PURE__*/React.createElement("line", {
    className: "ef8f3009-13e4-4b32-9373-4f26c104f898",
    x1: 35,
    y1: 160,
    x2: 35,
    y2: 117
  }), /*#__PURE__*/React.createElement("path", {
    className: "ef8f3009-13e4-4b32-9373-4f26c104f898",
    d: "M12,117.17a11.5,11.5,0,0,1,23,0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 176.5,
    r: 10.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "b68efef9-b17a-4f64-a3b4-b36a545fecf5",
    x1: 35.42,
    y1: 127.46,
    x2: 30.54,
    y2: 127.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "b68efef9-b17a-4f64-a3b4-b36a545fecf5",
    x1: 35.5,
    y1: 133.5,
    x2: 30.5,
    y2: 133.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "b68efef9-b17a-4f64-a3b4-b36a545fecf5",
    x1: 35.5,
    y1: 139.5,
    x2: 30.5,
    y2: 139.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "ac91a159-6e5f-459b-b0d8-f7558dcdaed1",
    x1: 24,
    y1: 176,
    x2: 24,
    y2: 130
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoefTempProfil);
export default __webpack_public_path__ + "static/media/coef_temp_profil.517b5b36a69bb79bf2d78be977d208bb.svg";
export { ForwardRef as ReactComponent };